document.addEventListener('DOMContentLoaded', () => {

  const widget = document.getElementById('subscription-widget');
  if (!widget) return;

  const bundleVolume = parseInt(widget.dataset.bundleVolume || 0, 10);

  const quantityInput = document.querySelector('input[name="quantity"]');
  const frequencyInputs = document.querySelectorAll('input[name="subscription_frequency"]');

  const dayContainer = document.getElementById('day-selector-container');
  const deliveryQty = document.getElementById('delivery-qty');
  const summary = document.getElementById('summary-content');

  const daysOfWeek = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  // ---------------------------
  // HELPERS
  // ---------------------------

  const getQuantity = () => parseInt(quantityInput?.value || 1, 10);
  const totalVolume = () => bundleVolume * getQuantity();

  const selectedFrequency = () =>
    document.querySelector('input[name="subscription_frequency"]:checked')?.value;

  const selectedDays = () => {

    const freq = selectedFrequency();
    if (!freq) return [];

    if (freq === 'daily') return daysOfWeek;

    if (freq === 'alternate') {
      const pattern = document.querySelector('input[name="alternate_pattern"]:checked')?.value;
      return pattern === 'mwfs'
        ? ['Monday','Wednesday','Friday','Sunday']
        : ['Tuesday','Thursday','Saturday'];
    }

    if (freq === 'weekly') {
      const el = document.querySelector('input[name="weekly_day"]:checked');
      return el ? [el.value] : [];
    }

    if (freq === 'twice') {
      return [...document.querySelectorAll('.twice-weekly-day:checked')].map(x => x.value);
    }

    return [];
  };

  // ---------------------------
  // FIRST DELIVERY RULE (NEW)
  // ---------------------------

  function getFirstDeliveryDate(days) {

    const today = new Date();
    let date = new Date(today);

    for (let i = 0; i < 14; i++) {

      const dayName = daysOfWeek[date.getDay()];

      if (days.includes(dayName)) {
        return new Date(date);
      }

      date.setDate(date.getDate() + 1);
    }

    return new Date(today);
  }

  // ---------------------------
  // DELIVERY SPLIT
  // ---------------------------

  function buildDeliveries(total, perDelivery) {

    if (!perDelivery || perDelivery <= 0) return [];

    const full = Math.floor(total / perDelivery);
    const remainder = total % perDelivery;

    let arr = [];

    for (let i = 0; i < full; i++) arr.push(perDelivery);

    if (remainder === 1 && arr.length) {
      arr[arr.length - 1] += 1;
    } else if (remainder >= 2) {
      arr.push(remainder);
    }

    return arr;
  }

  // ---------------------------
  // DATE GENERATION
  // ---------------------------

  function generateDates(days, count, startDate) {

    let results = [];
    let safety = 0;

    let date = new Date(startDate);
    date.setHours(0,0,0,0);

    const orderDate = new Date();
    orderDate.setHours(0,0,0,0);

    const nextDay = new Date(orderDate);
    nextDay.setDate(nextDay.getDate() + 1);

    const isBlocked = (d) => {
      const x = new Date(d);
      x.setHours(0,0,0,0);
      return x.getTime() === orderDate.getTime() ||
             x.getTime() === nextDay.getTime();
    };

    while (results.length < count && safety < 3650) {

      const dayName = daysOfWeek[date.getDay()];

      const allowedDay = days.includes(dayName);
      const notBlocked = !isBlocked(date);

      if (allowedDay && notBlocked) {
        results.push(new Date(date));
      }

      date.setDate(date.getDate() + 1);
      safety++;
    }

    return results;
  }

  // ---------------------------
  // DELIVERY DROPDOWN
  // ---------------------------

  function populateDeliveryDropdown() {

    const total = totalVolume();
    const currentValue = deliveryQty.value;

    deliveryQty.innerHTML = '<option value="">Select</option>';

    for (let i = 1; i <= total; i++) {
      const opt = document.createElement('option');
      opt.value = i;
      opt.textContent = `${i} Litre`;
      deliveryQty.appendChild(opt);
    }

    if (currentValue && currentValue <= total) {
      deliveryQty.value = currentValue;
    }
  }

  // ---------------------------
  // DAY SELECTOR
  // ---------------------------

  function buildDaySelector() {

    const freq = selectedFrequency();
    dayContainer.innerHTML = '';

    if (!freq) return;

    if (freq === 'alternate') {
      dayContainer.innerHTML = `
        <label><input type="radio" name="alternate_pattern" value="mwfs">MWFS</label>
        <label><input type="radio" name="alternate_pattern" value="tts">TTS</label>
      `;
    }

    if (freq === 'weekly') {
      dayContainer.innerHTML = daysOfWeek.map(d =>
        `<label><input type="radio" name="weekly_day" value="${d}">${d}</label>`
      ).join('');
    }

    if (freq === 'twice') {
      dayContainer.innerHTML = daysOfWeek.map(d =>
        `<label><input type="checkbox" class="twice-weekly-day" value="${d}">${d}</label>`
      ).join('');
    }

    dayContainer.querySelectorAll('input').forEach(el => {
      el.addEventListener('change', () => {
        const d = selectedDays();
        if (freq === 'twice' && d.length > 2) {
          el.checked = false;
          return;
        }
        updateSummary();
      });
    });
  }

  // ---------------------------
  // MAIN ENGINE
  // ---------------------------

  function updateSummary() {

    const freq = selectedFrequency();
    const days = selectedDays();
    const perDelivery = parseInt(deliveryQty.value || 0, 10);
    const total = totalVolume();

    populateDeliveryDropdown();

    if (!freq) {
      summary.innerHTML = "Select frequency";
      return;
    }

    if (!perDelivery) {
      summary.innerHTML = "Select litres per delivery";
      return;
    }

    const deliveries = buildDeliveries(total, perDelivery);

    // ✅ NEW LOGIC
    const firstDelivery = getFirstDeliveryDate(days);
    const start = firstDelivery;

    const dates = generateDates(days, deliveries.length, start);

    const schedule = dates.map((d, i) => {
      return `${d.toLocaleDateString('en-IN',{day:'2-digit',month:'short'})} - ${deliveries[i]}L`;
    });

    const prettyDays = days.join(', ');
    const durationWeeks = Math.ceil(deliveries.length / (days.length || 1));

    summary.innerHTML = `
      <p><b>Total:</b> ${total}L</p>
      <p><b>Delivery Days:</b> ${prettyDays}</p>
      <p><b>Deliveries:</b> ${deliveries.length}</p>
      <p><b>Duration:</b> ${durationWeeks} weeks</p>
      <div>${schedule.join('<br>')}</div>
    `;

    // ---------------------------
    // SHOPIFY SYNC FIELDS
    // ---------------------------

    document.getElementById('prop-frequency').value = freq;
    document.getElementById('prop-days').value = prettyDays;
    document.getElementById('prop-delivery-qty').value = `${perDelivery} Litre`;
    document.getElementById('prop-total-volume').value = `${total} Litre`;
    document.getElementById('prop-total-deliveries').value = deliveries.length;
    document.getElementById('prop-duration').value = `${durationWeeks} weeks`;
    document.getElementById('prop-schedule-json').value = JSON.stringify(schedule);

  }

  // ---------------------------
  // INIT EVENTS
  // ---------------------------

  populateDeliveryDropdown();

  frequencyInputs.forEach(el => {
    el.addEventListener('change', () => {
      buildDaySelector();
      updateSummary();
    });
  });

  quantityInput?.addEventListener('change', () => {
    populateDeliveryDropdown();
    updateSummary();
  });

  deliveryQty?.addEventListener('change', updateSummary);

});